export const clerkAppearance = {
  elements: {
    formButtonPrimary: 
      'bg-orange-600 hover:bg-orange-700 py-2 text-white font-semibold transition-colors',
    formButtonSecondary: 
      'border-orange-600 text-orange-600 hover:bg-orange-50',
    card: 
      'border-none bg-white rounded-sm border-gray-200 shadow-sm ',
    headerTitle: 
      'text-orange-400  font-bold text-2xl',
    headerSubtitle: 
      'text-gray-600',
    socialButtonsBlockButton: 
      'border-2 rounded py-2 border text-black hover:bg-orange-50 transition-colors',
    socialButtonsBlockButtonText: 
      'text-black font-medium',
    formFieldLabel: 
      'text-black font-medium',
    formFieldInput: 
      'border-gray-300 p-2 rounded focus:border-orange-600 focus:ring-orange-600',
    footerActionLink: 
      'text-orange-600 hover:text-orange-700 font-semibold',
    identityPreviewEditButton: 
      'text-orange-600 hover:text-orange-700',
    formFieldInputShowPasswordButton: 
      'text-orange-600 hover:text-orange-700 px-2',
    otpCodeFieldInput: 
      'border-gray-300 focus:border-orange-600 focus:ring-orange-600',
    formResendCodeLink: 
      'text-orange-600 hover:text-orange-700',
    dividerLine: 
      'bg-gray-200 mt-1',
    dividerText: 
      'text-gray-600',
    alternativeMethodsBlockButton: 
      'border-orange-600 text-orange-600 hover:bg-orange-50',
  },
  variables: {
    colorPrimary: '#ea580c', 
    colorBackground: '#ffffff',
    colorText: '#000000', 
    colorTextSecondary: '#4b5563', 
    colorDanger: '#dc2626', 
    colorSuccess: '#16a34a', 
    borderRadius: '0.5rem',
  },
};